module.exports = __webpack_public_path__ + "static/media/bUSDC-ETH SLP-logo.17cf781d.png";